import React, { useEffect, useState } from 'react';
import { getRefunds } from './refundService';
import RefundItem from './RefundItem';

const RefundList = () => {
  const [refunds, setRefunds] = useState([]);

  useEffect(() => {
    const fetchRefunds = async () => {
      try {
        const data = await getRefunds();
        setRefunds(data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchRefunds();
  }, []);

  return (
    <div className="p-3">
      <h3>Sale Refunds</h3>
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>ID</th>
            <th>Sale ID</th>
            <th>Refund Date</th>
            <th>Total Refund</th>
            <th>Cancellation Fee</th>
            <th>Loss Amount</th>
            <th>Status</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          {refunds.map((refund) => (
            <RefundItem key={refund.id} refund={refund} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RefundList;
